import { TicketUrgency } from '@/modules/Ticket/types/utils'
import React from 'react'
import { Control, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'
import FormLabel from '@/components/Form/FormLabel'
import helpContent from '@/modules/Ticket/help/ticket-priority-help.md'

interface Props {
    control: Control<any>
    onChange: (value: string) => void
}

const TicketPriority: React.FC<Props> = ({ control, onChange }) => {
    const { t } = useTranslation()
    const ticket_priority = useWatch({ control, name: 'ticket_priority' })
    const urgencyOptions = TicketUrgency(t)

    return (
        <div className="space-y-2">
            <FormLabel
                label={t('ticket-priority-label')}
                helpContent={helpContent}
                helpTitle={t('ticket-priority-help')}
            />
            <div className="flex items-center gap-2">
                {urgencyOptions?.map((item) => (
                    <Button
                        size="small"
                        key={item.value}
                        className="flex-1"
                        variant={
                            item.value === ticket_priority
                                ? 'contained'
                                : 'outlined'
                        }
                        onClick={() => onChange?.(item.value)}
                        type="button"
                    >
                        {item.value !== ticket_priority && (
                            <div className="w-1 h-1 rounded-full mr-2" />
                        )}
                        {item.label}
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default TicketPriority
